import { Point } from 'pixi.js-legacy';
import { CenterButton, CenterButtonOptions } from '../components';
export var UICallbacks;
(function (UICallbacks) {
    UICallbacks[UICallbacks["CenterButtonPress"] = 0] = "CenterButtonPress";
})(UICallbacks || (UICallbacks = {}));
export class UIManager {
    constructor() {
        this.callbacks = new Map();
    }
    static getInstance() {
        if (!this._instance) {
            this._instance = new UIManager();
        }
        return this._instance;
    }
    init(app, showCentreButton) {
        this.app = app;
        if (showCentreButton) {
            this.addCenterButton();
        }
    }
    subscribe(key, func) {
        this.callbacks.set(key, func);
    }
    unsubscribe(key) {
        this.callbacks.delete(key);
    }
    destroy() {
        this.callbacks.clear();
        UIManager._instance = undefined;
    }
    doResize() {
        if (this.centerButton) {
            this.centerButton.position.set(this.app.screen.width - 72, this.app.screen.height - 72);
        }
    }
    addCenterButton() {
        const centerButtonOpts = new CenterButtonOptions();
        centerButtonOpts.position = new Point(this.app.screen.width - 72, this.app.screen.height - 72);
        centerButtonOpts.xDim = 48;
        centerButtonOpts.yDim = 48;
        centerButtonOpts.onPress = () => {
            if (this.callbacks.has(UICallbacks.CenterButtonPress)) {
                this.callbacks.get(UICallbacks.CenterButtonPress)();
            }
        };
        this.centerButton = new CenterButton(centerButtonOpts);
        this.centerButton.zIndex = 100;
        this.app.stage.addChild(this.centerButton);
    }
}
